<script setup lang="ts">
import type { StrapiBlockList } from '@nimbus/types'

const props = defineProps<StrapiBlockList>()
</script>

<template>
    <component :is="props.format === 'ordered' ? 'ol' : 'ul'">
        <NimbusStrapiBlockRenderer :content="props.children" />
    </component>
</template>
